import { EdpeActions, EEdpeActions } from "@edp-store/actions/edpe.actions";
import { IEdpeState, initialEdpeState } from "@edp-store/state/edpe.state";

export function edpeReducers(state = initialEdpeState, action: EdpeActions): IEdpeState {
    switch (action.type) {
        case EEdpeActions.SetDashboardCards: {
            return {
                ...state,
                dashboardCards: action.payload,
            };
        }
        case EEdpeActions.SetDashboardGeneratedCodeCards: {
            return {
                ...state,
                dashboardGeneratedCodeCards: action.payload,
            };
        }
        case EEdpeActions.SetShowAlert: {
            return {
                ...state,
                showAlert: action.payload,
            };
        }
        case EEdpeActions.SetUserEfficiency: {
            return {
                ...state,
                userEfficiency: action.payload,
            };
        }
        case EEdpeActions.SetDashboardSections: {
            return {
                ...state,
                dashboardSections: action.payload,
            };
        }
        case EEdpeActions.SetLoadedDashboard: {
            return {
                ...state,
                loadedDashboard: action.payload,
            };
        }
        case EEdpeActions.SetUserAvailableParishList: {
            return {
                ...state,
                userAvailableParishList: action.payload,
            };
        }
        case EEdpeActions.SetUserParticipation: {
            return {
                ...state,
                userParticipation: action.payload,
            };
        }
        case EEdpeActions.SetMgmCode: {
            return {
                ...state,
                mgmCode: action.payload,
            };
        }
        case EEdpeActions.SetQuizzs: {
            return {
                ...state,
                quizzs: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
